<template>
  <div id="app">
    <fixed-container>
      <sky :scroll-position="scrollPosition" />
      <mountains :scroll-position="scrollPosition" />
      <hills :scroll-position="scrollPosition" />
      <trees :scroll-position="scrollPosition" />
      <front-hills :scroll-position="scrollPosition" />
    </fixed-container>
    <scroll-container @scroll-position-change="onScrollChange" />
    <!-- <fixed-container>
      <fore-ground :scroll-position="scrollPosition" />
    </fixed-container> -->
  </div>
</template>

<script>
import FixedContainer from 'components/FixedContainer';
import ScrollContainer from 'components/ScrollContainer';
import Sky from 'components/Sky';
import Mountains from 'components/Mountains';
import Hills from 'components/Hills';
import Trees from 'components/Trees';
import FrontHills from 'components/FrontHills';
import ForeGround from 'components/ForeGround';
// import appData from '@/data.json';
import inViewport from 'vue-in-viewport-directive';
import { trackPage } from './utils/track';

export default {
  name: 'App',
  directives: {
    inViewport,
  },
  components: {
    FixedContainer,
    ScrollContainer,
    ForeGround,
    Trees,
    FrontHills,
    Hills,
    Mountains,
    Sky,
  },
  data() {
    return {
      scrollPosition: 0,
    };
  },
  mounted() {
    trackPage('home');
  },
  methods: {
    onScrollChange(pos) {
      this.scrollPosition = pos;
    },
  },
};
</script>
<style lang="scss">
  * {
    box-sizing: border-box;
  }

  body,
  html {
    height: 100vh;
    width: 100%;
    background-color: #ffd661;
    font-family: $base-font;
    font-size: 1em;
    line-height: 1.5em;
    margin: 0;
    padding: 0;
  }

  #app {
    width: 100%;
    height: 100%;
    position: fixed;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue